export enum LITMUS_EXPERIMENT_NAMES {
  COLLECTION_FCM_FALLBACK = 'collections-fcm-fallback',
  COLLECTION_AMEYO_FIX = 'collection-ameyo-fix',
  COLLECTION_ENABLE_PAYMENT_SUCCESS_MODAL = 'collection-enable-payment-success-modal',
  COLLECTION_LONGHORN_THEME_ENABLE = 'collection-enable-theme',
  COLLECTION_AMEYO_TELE_POLLING = 'collection-ameyo-tele-polling',
  COLLECTION_AMEYO_TELE_V2 = 'collection-ameyo-tele-v2',
  COLLECTION_AMEYO_CALL_COUNT_POLLING = 'collection-ameyo-call-count-polling',
  COLLECTION_AMEYO_TELE_V3 = 'collection-ameyo-tele-v3',
  HRC_RECALIBRATE_ENABLE = 'hrc-recalibrate-enable',
  SKIP_TRACING_FEEDBACK_FORM = 'collection-skip-tracing-feedback-form',
  HRC_AMEYO_V3 = 'hrc-new-ameyo-integration'
}
